import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-cell-label',
  templateUrl: './cell-label.component.html',
  styleUrls: ['./cell-label.component.less'],
})
export class CellLabelComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
